import * as React from 'react';
import { Modal } from "../../../Modal";
import approachData from '../data/approachData';

import * as main from '../styles/main.module.scss';
import * as approach from '../styles/approach.module.scss';

export const Approach = ({ data={ approachData }, widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={approach.approach}>
      <div className="container">
        <h2 className={main.mainTitle}>Чем любой другой подход к изучению английского отличается от нашего?</h2>
        <div>
          <div className={approach.approach__block}>
            <div className={approach.approach__wrapper}>
              <div className={approach.approach__block_criteria}>Критерий</div>
              <div className={approach.approach__block_usual}>Обычная школа</div>
              <div className={approach.approach__block_advance}>
                <img
                  src="https://fs.advance.ru/landing-pages/online/angliyskiy_dlya_vashih_celey/_approach/advance-logo-podhod.svg"
                  alt={''}
                />
              </div>
            </div>
          </div>
          {approachData.map((elem, index) => (
            <div className={approach.approach__block} key={index}>
              <div className={approach.approach__wrapper} key={elem}>
                <div className={approach.approach__block_criteria}>{elem.criteria}</div>
                <div className={approach.approach__block_usual}>{elem.usual}</div>
                <div className={approach.approach__block_advance}>
                  <strong>{elem.advance}</strong>
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className={approach.approach__undertext}>
          Результат: по методике Advance за 3 месяца вы достигаете результата и больше не приходится проходить другие
          курсы
        </p>
        <button
          className={`${approach.approach__button} ${main.allBtn}`}
          onClick={() => {
            setShowModal(true);
          }}
        >
          Получить&nbsp;больше&nbsp;информации
        </button>
      </div>
      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        {widget}
      </Modal>
    </section>
  );
}
